import { WaterMeterRow } from '@/services/dashboardService'

export type CanonicalChartPoint = {
  x: string
  curr?: number
  second?: number
  prev?: number
  third?: number
}

/**
 * Transform water meter rows to canonical chart points with all 4 series
 * curr = dailySupply, second = dailyConsumption
 * prev = nightlySupply, third = nightlyConsumption
 */
export const transformWaterToChartPoints = (
  rows: WaterMeterRow[],
): CanonicalChartPoint[] => {
  return rows.map(row => ({
    x: row.day,
    curr: row.dailySupply,
    second: row.dailyConsumption,
    prev: row.nightlySupply,
    third: row.nightlyConsumption,
  }))
}

export const isCanonicalData = (data: any[]): boolean => {
  if (!data || data.length === 0) return false
  const first = data[0]
  return (
    typeof first?.x === 'string' &&
    ('curr' in first || 'second' in first || 'prev' in first || 'third' in first)
  )
}

export const isDateString = (str: string): boolean => /^\d{4}-\d{2}-\d{2}$/.test(str)
